module.exports = __webpack_public_path__ + "assets/img/mecha-34583a4d.png";